import { render } from "./SortByBadge.vue?vue&type=template&id=4e8e151c&scoped=true&lang=pug"
import script from "./SortByBadge.vue?vue&type=script&lang=js"
export * from "./SortByBadge.vue?vue&type=script&lang=js"

import "./SortByBadge.vue?vue&type=style&index=0&id=4e8e151c&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8e151c"]])

export default __exports__